import {makeAutoObservable} from "mobx";
import {IRmaProduct} from "../rma-types";

class RmaProductStore {
    private _model: IRmaProduct = {} as IRmaProduct;
    constructor(model: IRmaProduct) {
        makeAutoObservable(this, {}, { autoBind: true});
        this.setModel(model);
    }
    
    public setModel(model: IRmaProduct){
        this._model = model;
    }
    
    public get imageUrl(): string { return this._model.image; }
    public get name(): string { return this._model.product_name; }
    public get sku(): string | null { return this._model.sku; }
    public get variantTitle(): string | null { return this._model.variant_name; }
    public get price(): string { return this._model.price; }
}

export default RmaProductStore;